import { render, staticRenderFns } from "./BranchLearningSituation.vue?vue&type=template&id=30284829&scoped=true&lang=pug&"
import script from "./BranchLearningSituation.vue?vue&type=script&lang=ts&"
export * from "./BranchLearningSituation.vue?vue&type=script&lang=ts&"
import style0 from "./BranchLearningSituation.vue?vue&type=style&index=0&id=30284829&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30284829",
  null
  
)

export default component.exports